import { periodsHistory } from "@/api/home"

const state = {
    wWeeks: []
}

const mutations = {
    SET_WEEKS: (state, wWeeks) => {
        state.wWeeks = wWeeks
    }
}

const actions = {
    setWeeks({commit}) {
        return new Promise((resolve, reject) => {
            periodsHistory().then(res => {
                commit('SET_WEEKS', res.data)
                sessionStorage.setItem('wWeekLocalList', JSON.stringify(res.data))
                resolve()
            }).catch(err => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
